import NotificationChecked from 'assets/icons/old/notificationError.png';

const getToastLock = (elem, addToast) => addToast({ text: `${elem} is locked for editing`, src: NotificationChecked });

export default getToastLock;
